import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'app/core/config/application-config.service';

export interface RelatorioEntregasArquivosEfdPayload {
  numeroDocumento: string;
  competencia: string;
  sequencial: number | null;
}

@Injectable({ providedIn: 'root' })
export class RelatorioEntregasArquivosEfdService {

  resourceUrl = this.applicationConfigService.getEndpointFor('/sfz-sped-api-v2/api/relatorios/relatorioEntregasArquivosEfd');

  constructor(
    protected http: HttpClient,
    protected applicationConfigService: ApplicationConfigService
  ) {}

  gerarRelatorio(payload: RelatorioEntregasArquivosEfdPayload): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.post(this.resourceUrl, payload, {
      observe: 'response',
      responseType: 'arraybuffer'
    });
  }
}

